import axios from "axios";

export default function generateLeaseDocument(data, jwt) {
  return new Promise((resolve, reject) => {
    const backend_url = process.env.REACT_APP_BACKEND_URL;
    axios({
      url: `${backend_url}/lease-document/generate`,
      method: "POST",
      data,
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    })
      .then((res) =>
        resolve({
          data: res.data,
          error: false,
          complete: true,
        })
      )
      .catch((e) => {
        reject({
          data: null,
          error: true,
          errorMessage: e.response ? e.response.data : e,
          complete: true,
        });
      });
  });
}
